import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";

declare var ko: any;

export class modPointsReport_template extends vnTemplate {

    protected filter: filterSimple_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;

    protected getTemplateHtml(): string {

        return `


            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-users"></div>
                    <div id="selected-tags"></div>
                    <div id="selected-status"></div>
                    <div id="selected-moderation-status"></div>
                </div>
            </div>

            <div class="list-header w-justify" >

                <div class="w-center">
                        ` + this.filter.getHtmlBuild() + `
                </div>

                <div class="w-right">
                    ` + this.pagination.getHtmlBuild() + `
                </div>
            </div>

            <div class="w-list-results" id="list-results">
                <table class="list-results">
                    ` + this.resultInfos.getHtmlBuild() + `
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">ID</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'displayName') }, css: { 'list-sort-desc': orderByAndDirection()=='displayName_DESC', 'list-sort-asc': orderByAndDirection()=='displayName_ASC' }">Display Name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'firstName') }, css: { 'list-sort-desc': orderByAndDirection()=='firstName_DESC', 'list-sort-asc': orderByAndDirection()=='firstName_ASC' }">First Name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'lastName') }, css: { 'list-sort-desc': orderByAndDirection()=='lastName_DESC', 'list-sort-asc': orderByAndDirection()=='lastName_ASC' }">Last Name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'loginName') }, css: { 'list-sort-desc': orderByAndDirection()=='loginName_DESC', 'list-sort-asc': orderByAndDirection()=='loginName_ASC' }">Email</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'modPointsEarned') }, css: { 'list-sort-desc': orderByAndDirection()=='modPointsEarned_DESC', 'list-sort-asc': orderByAndDirection()=='modPointsEarned_ASC' }">Points</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'modCount') }, css: { 'list-sort-desc': orderByAndDirection()=='modCount_DESC', 'list-sort-asc': orderByAndDirection()=='modCount_ASC' }">Mod Count</span></th>
    
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: mods">
                        <tr class="cursor">
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click"><span data-bind="text: id"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }" ><a class="right-click"><span data-bind="text: displayName"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }" ><a class="right-click"><span data-bind="text: firstName"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }" ><a class="right-click"><span data-bind="text: lastName"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }" ><a class="right-click"><span data-bind="text: loginName"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }" ><a class="right-click"><span data-bind="text: modPointsEarned"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }" ><a class="right-click"><span data-bind="text: modCount"></span></a></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            `;
    }

    protected initPartial(): void {

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 20;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);

    }

    protected getTemplateName(): string {
        return "modPointsReport_template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return {
            orderBy: ko.observable("displayName")
            , orderByDirection: ko.observable("ASC")
            , mods: ko.observableArray([])
            , orderByAndDirection: ko.observable("displayName_ASC")
            , isAddButtonShown: ko.observable(true)
            , onClickReorder: function (value, data, event) {
                huit_neuf_this.onClickReorder(value, data, event);
            }
            , onClickAdd: function () {
                huit_neuf_this.onClickAdd();
            }
            , onClickView: function (data) {
                huit_neuf_this.onClickView(data);
            }
            , onClickViewOnSite: function (data) {
                huit_neuf_this.onClickViewOnSite(data);
            }
        };
    }

    // implementation of base class [vnTemplate]
    public getViewModelForRequest() {

        return {
            orderBy: this.getTemplateViewModel().orderBy
            , orderByDirection: this.getTemplateViewModel().orderByDirection
            , orderByAndDirection: this.getTemplateViewModel().orderByAndDirection
            , pagination: this.getTemplateViewModel().pagination
            ,filters : {
                keywords : this.getTemplateViewModel().filter.filterKeyword
            },
        }
    }


    public onClickReorder(value, data, event) {

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.listReorder();
    }

    public setViewModelFromRequest(urlParams){

        if (urlParams == null){
            return;
        }

        let keywordString = urlParams.keywords
        if(urlParams.keywords){
            keywordString = urlParams.keywords.replaceAll("+", " ");
        }

        this.filter.getTemplateViewModel().filterKeyword(keywordString);
    }

    public setFilterSelectedItems(objFilter, urlParams){

        let splitString = [];

        // Multi select filters.
        if(urlParams){
            if(typeof urlParams == "string"){
                splitString = urlParams.split(",");
            }else if(Array.isArray(urlParams)){
                splitString = urlParams;
            }else{
                splitString = [urlParams];
            }
            let arrayParam = [];
            let idTagArray = [];
            splitString.forEach((id) => {
                if(!isNaN(Number(id))){
                    id = Number(id);
                }else{
                    id = id.replaceAll("+", " ");
                }
                arrayParam.push({ id: id });
                idTagArray.push(id);
            });
            objFilter.setSelectedItems(arrayParam);
            objFilter.setTags(idTagArray, objFilter.getItems());
        }else{
            objFilter.setSelectedItems([]);
            objFilter.setTags([], objFilter.getItems());
        }
    }

    public onClickAdd() {

        this.caller.add();
    }

    public setMods(data) {

        this.getTemplateViewModel().mods(data);
    }

    public onClickView(data){

        this.caller.viewPointDetails(data.id);
    }

    public onClickViewOnSite(data) {

        this.caller.viewOnSite(data);
    }

    public setResultInfo(nbResults, nbPages, execTime ) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/modPointsReport_template.ts